import { ExclamationCircleIcon } from '@heroicons/react/16/solid';
import classNames from 'classnames';

interface FieldErrorProps {
  message: string;
  cyTag?: string;
  className?: string;
  id?: string;
  tabIndex?: number;
}

/** Renders a field validation error with icon below the field.
 *  Integrates with React Hook Form ErrorMessage component. */
const FieldError = (props: FieldErrorProps) => {
  const { message, cyTag, className, id, tabIndex } = props;
  // `className` REPLACES the default top-margin slot (mt-1.5) rather than being
  // concatenated onto it. This repo has no tailwind-merge, so a caller-supplied
  // margin utility (e.g. "mt-0", "mt-2") would otherwise sit alongside mt-1.5 with
  // equal specificity/layer -- Tailwind's compiled emit order decides the winner,
  // not the override intent. Callers that only need a different vertical offset
  // should pass their own margin utility; anything else should be composed
  // alongside a margin utility rather than relying on the default.
  return (
    <div
      role="alert"
      id={id}
      tabIndex={tabIndex}
      className={classNames('flex items-center gap-1', className ?? 'mt-1.5')}
      data-cy={cyTag}
    >
      <ExclamationCircleIcon aria-hidden="true" className="size-4 text-error-50 shrink-0" />
      <p className="body-text text-error-50 text-left">{message}</p>
    </div>
  );
};

export default FieldError;
